import React, { useEffect, useState } from 'react';
import AppTitle from '../../../layouts/AppTitle';
import { featureBg } from '../../../../assets/images';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { validateUserOTP } from '../../../../store/actions/AuthActions';
import { userValidateForm } from '../../../../utils/formElements';
import renderElements from '../../../../utils/renderElements';
import { CircularProgress } from '@mui/material';

const ValidateRegister = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [values, setValues] = useState({});

  const btnLoaderOne = useSelector(state => state?.app?.btnLoaderOne);
  const registrationForm = useSelector(state => state?.app?.registrationForm);

  useEffect(() => {
    if (registrationForm) {
      setValues({ email: registrationForm?.email });
    }
  }, [registrationForm]);

  const handleSubmit = e => {
    e.preventDefault();
    const submitValues = { email: registrationForm?.email, otp: Number(values?.otp) };
    dispatch(validateUserOTP(submitValues, navigate));
  };

  const handleChange = e => {
    setValues({ ...values, [e?.target?.name]: e?.target?.value });
  };

  return (
    <div>
      <AppTitle
        bgImg={featureBg}
        title={'Email Verification'}
        to={'Verify'}
        from={'Register'}
        link='/register'
      />

      <div className='section-padding-03 contact-section2 contact-section2_bg'>
        <div className='container custom-container'>
          <div className='row'>
            <div className='col-md-6'>
              <div className='contact-section2_content'>
                <h2 className='contact-section2__title'>Already a Customer</h2>
                <p className='contact-section2__text'>
                  By creating an account with our store, you will be able to move through the
                  checkout process faster, store multiple shipping addresses, view and track your
                  orders in your account and more.
                </p>
                <button
                  className='btn btn-secondary btn-hover-primary'
                  type='submit'
                  value='Send Massage'
                  onClick={() => navigate('/register')}
                >
                  Register
                </button>
              </div>
            </div>
            <div className='col-md-6'>
              <div className='contact-section2_formbg'>
                <h2 className='contact-section2_form__title'>Register...</h2>

                <form className='contact-section2_form' id='contact-form' onSubmit={handleSubmit}>
                  <div className='row'>
                    {userValidateForm?.map((element, i) => (
                      <div className='col-12 form-p'>
                        {renderElements({ element, setValues, values, handleChange })}
                      </div>
                    ))}

                    <div className='col-md-12 form-p'>
                      <div className='form-group mb-0 d-flex justify-content-center'>
                        <button
                          className='btn btn-secondary btn-hover-primary'
                          type='submit'
                          value='Send Massage'
                          disabled={btnLoaderOne}
                        >
                          {btnLoaderOne ? 'Submitting...' : 'Submit'}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                <div className='form-messege'></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValidateRegister;
